import React, { useContext } from 'react';
import Inputs from 'components/Inputs';
import { UIVersionContext } from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

const AccountPicker = ({
  isSearchVisible,
  options,
}: {
  isSearchVisible: boolean;
  options: DropdownOption[];
}) => {
  const { uiVersion } = useContext(UIVersionContext);

  if (uiVersion === 'v3') {
    return (
      <Inputs.Dropdown
        options={options}
        isSearchEnabled={isSearchVisible}
        listWidth={250}
      />
    );
  }

  return (
    <div style={{ marginBottom: 8 }}>
      <Inputs.Dropdown options={options} isSearchEnabled={isSearchVisible} />
    </div>
  );
};

export default AccountPicker;
